export default function getResource(label, vars = []) {
    const resources = {
        addToBasketShort: 'Ajouter',
        remove: 'Supprimer',
        joinToAccess: 'Adhérer pour accéder',
        signInToAccess: 'Ouvrez une session pour accéder',
        exclusive: 'Exclusivement'
    };
    return resources[label];
}
